<template>
  <div class="zhezhao" v-if="showSignUp">
    <div class="demo-container tankuang">
      <div class="header">
        <div class="header-right" o @click="hidder()">x</div>
      </div>

      <div class="demo-left" style="overflow-x: scroll">
        <div
          id="step1Box"
          class="step-box animated fadeInUp"
          style="display: flex; flex-direction: column"
          v-if="currentStep == 'one'"
        >
          <div class="my-title-box">
            <div class="my-title">岗位选择</div>
            <!-- <div class="my-subtitle"></div> -->
          </div>
          <el-table
            ref="postList"
            :data="recruitPostList"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            border
            height="250"
            style="width: 100%"
          >
            <el-table-column
              fixed
              label="操作"
              column-key="id"
              align="center"
              width="70px"
            >
              <template slot-scope="scope">
                <!-- <el-checkbox
                  :disabled="signupInfo.status > 1"
                  v-model="scope.row.checked"
                /> -->
                <el-radio
                  :disabled="signupInfo.status == 1 || scope.row.filled == 1"
                  :label="scope.row.id"
                  v-model="signupInfo.postId"
                  @change="choosePost(scope.row)"
                >
                  <br /><span v-if="scope.row.filled == 1"
                    >已招满</span
                  ></el-radio
                >
                <!-- <el-radio v-model="scope.row.checked" /> -->
              </template>
            </el-table-column>

            <el-table-column prop="unit" label="招聘单位" width="150">
            </el-table-column>
            <el-table-column prop="subsidiary" label="部门/子公司" width="150">
            </el-table-column>
            <el-table-column prop="name" label="岗位名称" width="120">
            </el-table-column>
            <el-table-column prop="code" label="岗位代码" width="120">
            </el-table-column>
            <el-table-column
              prop="majorCategory"
              label="专业类别"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="majorDemand"
              label="专业要求"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="education"
              label="学历要求"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="workExperience"
              label="工作经验要求"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <el-button type="text" size="small">编辑</el-button>
              </template>
            </el-table-column> -->
          </el-table>

          <div class="mybtns" v-if="noticeInfo.sendResume == 0">
            <button
              class="step2 default-btn next-step"
              @click="nextStep('two')"
            >
              {{
                signupInfo.status && signupInfo.status != 3
                  ? "查看报名信息"
                  : "填写报名信息"
              }}
            </button>
          </div>
          <div class="mybtns" v-if="noticeInfo.sendResume == 1">
            <button
              class="step2 default-btn next-step"
              @click="nextStep('two')"
            >
              {{
                signupInfo.status && signupInfo.status != 3
                  ? "查看简历信息"
                  : "填写简历信息"
              }}
            </button>
          </div>
        </div>

        <div class="step-box animated" v-if="currentStep == 'two'">
          <div class="my-title-box" style="height: 50px; text-align: center">
            <div class="my-title">个人信息登记表</div>
            <div class="my-subtitle"></div>
          </div>

          <table class="table" cellspacing="0" cellpading="0" border="0">
            <tr>
              <td style="width: 120px">
                <font style="color: red">*</font>姓名
              </td>
              <td>
                {{ signupInfo.name }}
              </td>
              <td style="width: 120px">
                <font style="color: red">*</font>性别
              </td>
              <td>
                {{ signupInfo.gender == 1 ? "男" : "女" }}
              </td>
              <td style="width: 60px !important">
                <font style="color: red">*</font>出生年月
              </td>
              <td style="width: 205px !important">
                {{ signupInfo.birthday }}
              </td>

              <td rowspan="4" style="width: 139px; height: 139px">
                <img :src="signupInfo.headUrl" width="130px" height="160px" />
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>联系电话</td>
              <td style="width: 160px !important">
                {{ signupInfo.telephone }}
              </td>
              <td><font style="color: red">*</font>电子邮箱</td>
              <td>
                {{ signupInfo.email }}
              </td>
              <td><font style="color: red">*</font>身份证号</td>
              <td>
                {{ signupInfo.cardNum }}
              </td>
            </tr>
            <tr>
              <td style="width: 120px">
                <font style="color: red">*</font>民族
              </td>
              <td>
                <select id="nation" name="nation" v-model="signupInfo.nation">
                  <option selected disabled hidden value=""></option>
                  <option
                    v-for="(item, index) in nations"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <!--              <td><font style="color: red">*</font>籍贯</td>-->
              <td><font style="color: red">*</font>户籍地</td>
              <td>
                <el-cascader
                  class="form-input-native-place"
                  placeholder="请选择籍贯"
                  :options="nativePlaceOptions"
                  :props="treeSelect"
                  filterable
                  clearable
                  v-model="signupInfo.nativePlaceInfo"
                  @change="handleChange"
                  ref="cascader_Ref"
                />
                <!-- <el-cascader
                  class="form-input-native-place"
                  placeholder="请选择籍贯"
                  :options="nativePlaceOptions"
                  :props="treeSelect"
                  filterable
                  clearable
                  v-model="signupInfo.nativePlaceInfo"
                /> -->
                <el-input
                  style="width: 130px !important"
                  v-model="signupInfo.nativeAddress"
                  placeholder="详细地址"
                />
              </td>
              <td><font style="color: red">*</font>出生地</td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="signupInfo.birthAddress"
                  placement="top"
                >
                  <input
                    style="width: 160px !important"
                    type="text"
                    v-model="signupInfo.birthAddress"
                  />
                </el-tooltip>
              </td>
            </tr>
            <tr>
              <td><font style="color: red">*</font>政治面貌</td>
              <td>
                <select
                  id="political"
                  name="political"
                  v-model="signupInfo.political"
                >
                  <option selected disabled hidden value=""></option>
                  <option value="群众">群众</option>
                  <option value="共青团员">共青团员</option>
                  <option value="预备党员">预备党员</option>
                  <option value="中共党员">中共党员</option>
                  <option value="其他">其他</option>
                </select>
              </td>
              <td><font style="color: red">*</font>婚否</td>
              <td>
                <div style="display: flex; border: none">
                  <div
                    style="flex: 1; border-right: 1px solid #ddd; padding: 5px"
                  >
                    <select v-model="signupInfo.isMarry">
                      <option selected disabled hidden value=""></option>
                      <option value="未婚">未婚</option>
                      <option value="已婚">已婚</option>
                      <option value="离异">离异</option>
                    </select>
                  </div>

                  <div
                    style="
                      flex: 1;
                      border-right: 1px solid #ddd;
                      padding: 5px;
                      font-size: 16px;
                      width: 70px;
                    "
                  >
                    <font style="color: red">*</font>身高
                  </div>
                  <div style="flex: 1; padding: 5px">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="signupInfo.height"
                      placement="top"
                    >
                      <input
                        style="width: 100px !important"
                        type="text"
                        onkeyup="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                        v-model="signupInfo.height"
                      />
                    </el-tooltip>
                    cm
                  </div>
                </div>
              </td>
              <td><font style="color: red">*</font>健康状况</td>
              <td>
                <select v-model="signupInfo.health">
                  <option selected disabled hidden value=""></option>
                  <option value="健康">健康</option>
                  <option value="良好">良好</option>
                  <option value="其他">其他</option>
                </select>
              </td>
            </tr>

            <tr>
              <td><font style="color: red">*</font>最高学历</td>
              <td>
                <el-select
                  v-model="signupInfo.degree"
                  clearable
                  class="form-select-max-educationType-type"
                  placeholder="请选择最高学历"
                   @change="educationTypeChange"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :value="item.value"
                    :label="item.name"
                  />
                </el-select>
              </td>
              <td><font style="color: red">*</font>教育类型</td>
              <td>
                <div style="display: flex; border: none">
                  <div
                    style="flex: 1; border-right: 1px solid #ddd; padding: 5px"
                  >
                    <el-select
                      v-model="signupInfo.educationType"
                      clearable
                      class="form-select-educationType-type"
                      placeholder="请选择是否全日制教育"
                      @change="educationTypeChange"
                    >
                      <el-option :value="1" label="全日制" />
                      <el-option :value="2" label="非全日制" />
                    </el-select>
                  </div>
                  <div
                    style="
                      flex: 1;
                      border-right: 1px solid #ddd;
                      padding: 5px;
                      font-size: 16px;
                      width: 70px;
                      line-height: 40px;
                    "
                  >
                    <font style="color: red">*</font>是否缴纳过社保
                  </div>
                  <div style="flex: 1; padding: 5px">
                    <el-select
                      v-model="signupInfo.socialInsurance"
                      clearable
                      class="form-select-educationType-type"
                      placeholder="请选择是否缴纳过社保"
                    >
                      <el-option :value="0" label="否" />
                      <el-option :value="1" label="是" />
                    </el-select>
                  </div>
                </div>
              </td>
              <td><font style="color: red">*</font>现住址</td>
              <td colspan="2">
                <el-cascader
                  class="form-input-native-place"
                  placeholder="请选择现住址"
                  :options="presentAddressOptions"
                  :props="treeSelect"
                  filterable
                  clearable
                  v-model="signupInfo.currentInfo"
                />
                <el-input
                  style="width: 160px !important"
                  v-model="signupInfo.currentAddress"
                  placeholder="详细地址"
                />
              </td>
            </tr>
            <tr>
              <td class="tdcenter">
                <font style="color: red">*</font>参加工作时间
              </td>
              <td colspan="2">
                <el-date-picker
                  style="width: 160px !important"
                  v-model="signupInfo.workTime"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </td>
              <td><font style="color: red">*</font>现工作单位</td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="signupInfo.workCompany"
                  placement="top"
                >
                  <input
                    type="text"
                    style="width: 160px !important"
                    v-model="signupInfo.workCompany"
                  />
                </el-tooltip>
              </td>
              <td><font style="color: red">*</font>现工作部门及岗位</td>
              <td colspan="2">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="signupInfo.workDeptPost"
                  placement="top"
                >
                  <input
                    type="text"
                    style="width: 160px !important"
                    v-model="signupInfo.workDeptPost"
                  />
                </el-tooltip>
              </td>
            </tr>
            <tr>
              <td colspan="7" class="tdcenter">
                <font style="color: red">*</font
                >温馨提示:所指亲属包括：(一)配偶；(二)直系血亲关系，包括祖父母、外祖父母、父母、子女、孙子女、外孙子女；(三)三代以内旁系血亲关系，包括叔伯姑舅姨、兄弟姐妹及其子女、表(堂)兄弟姐妹及其子女；(四)近姻亲关系，包括配偶的父母，配偶的兄弟姐妹及其配偶、子女，配偶的表(堂)兄弟姐妹及其子女，子女的配偶及子女配偶的父母，三代以内旁系血亲的配偶。
              </td>
            </tr>
            <tr>
              <td class="tdcenter">
                <font style="color: red">*</font>是否有亲属在拟应聘企业及上级企业任职
              </td>
              <td colspan="1">
                <el-select
                      v-model="signupInfo.qsIn"
                      clearable
                      class="form-select-educationType-type"
                      placeholder="请选择"
                    >
                      <el-option :value="0" label="否" />
                      <el-option :value="1" label="是" />
                    </el-select>
              </td>
              <td ><font  v-if="signupInfo.qsIn"style="color: red">*</font><span v-if="signupInfo.qsIn">亲属关系</span></td>
              <td>
                <el-tooltip
                v-if="signupInfo.qsIn"
                  class="item"
                  effect="dark"
                  :content="signupInfo.qsRelation"
                  placement="top"
                >
                  <input
                   v-if="signupInfo.qsIn"
                    type="text"
                    style="width: 160px !important"
                    v-model="signupInfo.qsRelation"
                  />
                </el-tooltip>
              </td>
              <td><font style="color: red"  v-if="signupInfo.qsIn">*</font><span v-if="signupInfo.qsIn">任职单位及职务</span></td>
              <td colspan="2">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="signupInfo.qsUnit"
                  placement="top"
                >
                  <input
                   v-if="signupInfo.qsIn"
                    type="text"
                    style="width: 160px !important"
                    v-model="signupInfo.qsUnit"
                  />
                </el-tooltip>
              </td>
            </tr>

            <tr>
              <td><font style="color: red">*</font>应聘单位</td>
              <td colspan="2">
                {{ signupInfo.companyName }}
              </td>
              <td><font style="color: red">*</font>应聘岗位序列号</td>
              <td>
                {{ signupInfo.postNum }}
              </td>
              <td><font style="color: red">*</font>应聘岗位名</td>
              <td colspan="2">
                {{ signupInfo.postName }}
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td colspan="7" class="tdcenter">
                <font style="color: red">*</font
                >温馨提示:学历如不涉及对应阶段,起止时间任选,院校专业填"无",否则无法提交报名。
              </td>
            </tr>
            <tr v-if="signupInfo.degree && signupInfo.educationType">
              <td class="tdcenter"></td>
              <td>起止时间</td>
              <td>教育类型</td>
              <td>学校名称（具体到院系）</td>
              <td>专 业</td>
              <td>学历</td>
              <td>院校类别</td>
            </tr>
            <tr v-if="signupInfo.degree == '6' && signupInfo.educationType">
              <td class="tdcenter">
                <font style="color: red">*</font>博士阶段
              </td>
              <td>
                <el-date-picker
                  @change="eduTimeChange($event, 'zgEducation')"
                  style="width: 210px !important"
                  v-model="zgEducation.startEndTime"
                  type="daterange"
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                >
                </el-date-picker>
              </td>
              <td>
                <el-select
                  v-model="zgEducation.educationType"
                  clearable
                  class="form-select-educationType-type"
                  placeholder="请选择是否全日制教育"
                  :disabled="signupInfo.degree == '6'"
                >
                  <el-option :value="1" label="全日制" />
                  <el-option :value="2" label="非全日制" />
                </el-select>
              </td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="zgEducation.college"
                  placement="top"
                >
                  <input
                    type="text"
                    v-model="zgEducation.college"
                    style="width: 230px !important"
                  />
                </el-tooltip>
              </td>

              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="zgEducation.major"
                  placement="top"
                >
                  <input type="text" v-model="zgEducation.major" />
                </el-tooltip>
              </td>
              <td>
                <el-select
                  clearable
                  class="el-select-dense"
                  v-model="zgEducation.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select
                  v-model="zgEducation.schoolType"
                  clearable
                  class="full-time-message-department"
                  placeholder="请选择院校类别"
                >
                  <el-option
                    v-for="(item, index) in schoolFeatureList"
                    :key="index"
                    :value="Number(item.dictValue)"
                    :label="item.dictLabel"
                  />
                </el-select>
              </td>
            </tr>
            <tr v-if="signupInfo.degree >= 5 && signupInfo.educationType">
              <td class="tdcenter">
                <font style="color: red">*</font>研究生阶段
              </td>
              <td>
                <el-date-picker
                  @change="eduTimeChange($event, 'yjsEducation')"
                  style="width: 210px !important"
                  v-model="yjsEducation.startEndTime"
                  type="daterange"
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                >
                </el-date-picker>
              </td>
              <td>
                <el-select
                  v-model="yjsEducation.educationType"
                  clearable
                  class="form-select-educationType-type"
                  placeholder="请选择是否全日制教育"
                  :disabled="signupInfo.degree == '5'"
                >
                  <el-option :value="1" label="全日制" />
                  <el-option :value="2" label="非全日制" />
                </el-select>
              </td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="yjsEducation.college"
                  placement="top"
                >
                  <input
                    type="text"
                    v-model="yjsEducation.college"
                    style="width: 230px !important"
                  />
                </el-tooltip>
              </td>

              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="yjsEducation.major"
                  placement="top"
                >
                  <input type="text" v-model="yjsEducation.major" />
                </el-tooltip>
              </td>
              <td>
                <el-select
                  clearable
                  class="el-select-dense"
                  v-model="yjsEducation.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select
                  v-model="yjsEducation.schoolType"
                  clearable
                  class="full-time-message-department"
                  placeholder="请选择院校类别"
                >
                  <el-option
                    v-for="(item, index) in schoolFeatureList"
                    :key="index"
                    :value="Number(item.dictValue)"
                    :label="item.dictLabel"
                  />
                </el-select>
              </td>
            </tr>
            <tr v-if="signupInfo.degree >= 4 && signupInfo.educationType">
              <td class="tdcenter">
                <font style="color: red">*</font>本科阶段
              </td>
              <td>
                <el-date-picker
                  @change="eduTimeChange($event, 'fullEducation')"
                  style="width: 210px !important"
                  v-model="fullEducation.startEndTime"
                  type="daterange"
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                >
                </el-date-picker>
              </td>
              <td>
                <el-select
                  v-model="fullEducation.educationType"
                  clearable
                  class="form-select-educationType-type"
                  placeholder="请选择是否全日制教育"
                  :disabled="signupInfo.degree == '4'"
                >
                  <el-option :value="1" label="全日制" />
                  <el-option :value="2" label="非全日制" />
                </el-select>
              </td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="fullEducation.college"
                  placement="top"
                >
                  <input
                    type="text"
                    v-model="fullEducation.college"
                    style="width: 230px !important"
                  />
                </el-tooltip>
              </td>

              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="fullEducation.major"
                  placement="top"
                >
                  <input type="text" v-model="fullEducation.major" />
                </el-tooltip>
              </td>
              <td>
                <el-select
                  clearable
                  class="el-select-dense"
                  v-model="fullEducation.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select
                  v-model="fullEducation.schoolType"
                  clearable
                  class="full-time-message-department"
                  placeholder="请选择院校类别"
                >
                  <el-option
                    v-for="(item, index) in schoolFeatureList"
                    :key="index"
                    :value="Number(item.dictValue)"
                    :label="item.dictLabel"
                  />
                </el-select>
              </td>
            </tr>
            <tr v-if="signupInfo.degree && signupInfo.educationType">
              <td class="tdcenter">
                <font style="color: red">*</font>专科及以下阶段
              </td>
              <td>
                <el-date-picker
                  @change="eduTimeChange($event, 'zkEducation')"
                  style="width: 210px !important"
                  v-model="zkEducation.startEndTime"
                  type="daterange"
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                >
                </el-date-picker>
              </td>
              <td>
                <el-select
                  v-model="zkEducation.educationType"
                  clearable
                  class="form-select-educationType-type"
                  placeholder="请选择是否全日制教育"
                  :disabled="signupInfo.degree <= 3"
                >
                  <el-option :value="1" label="全日制" />
                  <el-option :value="2" label="非全日制" />
                </el-select>
              </td>
              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="zkEducation.college"
                  placement="top"
                >
                  <input
                    type="text"
                    v-model="zkEducation.college"
                    style="width: 230px !important"
                  />
                </el-tooltip>
              </td>

              <td>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="zkEducation.major"
                  placement="top"
                >
                  <input type="text" v-model="zkEducation.major" />
                </el-tooltip>
              </td>
              <td>
                <el-select
                  clearable
                  v-model="zkEducation.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select
                  v-model="zkEducation.schoolType"
                  clearable
                  class="full-time-message-department"
                  placeholder="请选择院校类别"
                >
                  <el-option
                    v-for="(item, index) in schoolFeatureList"
                    :key="index"
                    :value="Number(item.dictValue)"
                    :label="item.dictLabel"
                  />
                </el-select>
              </td>
            </tr>

            <tr v-if="false">
              <td class="tdcenter">非全日制<br />教育情况<br />(最高学历)</td>
              <td colspan="2">
                <el-date-picker
                  style="width: 210px !important"
                  v-model="partEducation.startEndTime"
                  type="daterange"
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </td>
              <td>
                <input
                  type="text"
                  v-model="partEducation.college"
                  style="width: 160px !important"
                />
              </td>
              <td><input type="text" v-model="partEducation.major" /></td>
              <td>
                <el-select
                  clearable
                  v-model="partEducation.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in degreeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-select
                  v-model="partEducation.schoolType"
                  clearable
                  class="full-time-message-department"
                  placeholder="请选择院校类别"
                >
                  <el-option
                    v-for="(item, index) in schoolFeatureList"
                    :key="index"
                    :value="Number(item.dictValue)"
                    :label="item.dictLabel"
                  />
                </el-select>
              </td>
            </tr>

            <tr>
              <td>工作经历(按时间先后顺序填写)</td>
              <td colspan="6" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td
                      align="center"
                      style="border-left: none; border-top: none"
                    >
                      起止时间
                    </td>
                    <td colspan="2" align="center" style="border-top: none">
                      单位及部门
                    </td>
                    <td colspan="2" align="center" style="border-top: none">
                      岗位及职务
                    </td>
                    <td align="center" style="border-top: none">
                      主要工作职责
                    </td>
                  </tr>

                  <tr v-for="(item, index) in workExperienceList" :key="index">
                    <td align="center">
                      <el-date-picker
                        @change="workTimeChange($event, item)"
                        v-model="item.startEndTime"
                        type="daterange"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        unlink-panels
                      >
                      </el-date-picker>
                    </td>
                    <td colspan="2" align="center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.unitDept"
                        placement="top"
                      >
                        <input
                          type="text"
                          v-model="item.unitDept"
                          style="width: 260px !important"
                        />
                      </el-tooltip>
                    </td>
                    <td colspan="2" align="center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.post"
                        placement="top"
                      >
                        <input
                          type="text"
                          v-model="item.post"
                          style="width: 250px !important"
                        />
                      </el-tooltip>
                    </td>
                    <td align="center">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.duty"
                          placement="top"
                        >
                          <input type="text" v-model="item.duty" />
                        </el-tooltip>

                        <span
                          v-if="item.id.length > 1"
                          @click="delrow(item)"
                          style="
                            justify-content: center;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: red;
                          "
                          >移除</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-right: none" colspan="6">
                      <span
                        class="rowBtn"
                        @click="addrow()"
                        style="
                          justify-content: center;
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                        >加一行</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="tdcenter">获得奖励<br />情况</td>
              <td colspan="6">
                <textarea rows="2" v-model="signupInfo.rewards"></textarea>
              </td>
            </tr>
            <tr>
              <td>相关资格证书（专业技术资格、职（执）业资格等）</td>
              <td colspan="6" style="padding: 0px">
                <table
                  style="width: 100%"
                  class="innertable"
                  cellspacing="0"
                  cellpading="0"
                  id="family"
                >
                  <tr>
                    <td
                      colspan="2"
                      align="center"
                      style="border-left: none; border-top: none"
                    >
                      名称
                    </td>
                    <td colspan="2" align="center" style="border-top: none">
                      等级
                    </td>
                    <td align="center" style="border-top: none">获得时间</td>
                    <td align="center" style="border-top: none">颁发机构</td>
                  </tr>
                  <tr v-for="(item, index) in certificateList" :key="index">
                    <td colspan="2">
                      <input
                        type="text"
                        v-model="item.name"
                        style="width: 450px !important"
                      />
                    </td>
                    <td colspan="2">
                      <input
                        type="text"
                        v-model="item.grade"
                        style="width: 300px !important"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        v-model="item.getTime"
                        style="width: 300px !important"
                      />
                    </td>
                    <td>
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <input type="text" v-model="item.organization" />
                        <span
                          v-if="item.id.length > 1"
                          @click="delrowCert(item)"
                          style="
                            justify-content: center;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: red;
                          "
                          >移除</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-right: none" colspan="5">
                      <span
                        class="rowBtn"
                        @click="addrowCert()"
                        style="
                          justify-content: center;
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                        >加一行</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="tdcenter">其他需说明的情况</td>
              <td colspan="6">
                <textarea rows="2" v-model="signupInfo.remark"></textarea>
              </td>
            </tr>
            <tr v-if="recruitNoticeInfo.promise">
              <td class="tdcenter">
                <font class="tdcenter" style="color: red">*</font>个人诚信承诺书
              </td>
              <td colspan="6">
                <el-upload
                  class="avatar-uploader upload_table"
                  :action="uploadImgUrl"
                  :show-file-list="false"
                  :on-success="promiseUploadSuccess"
                  :before-upload="handleBeforeUpload"
                  :headers="headers"
                  :limit="1"
                  :disabled="signupInfo.status > 1"
                  accept=".jpg,.png,.jpeg"
                >
                  <img
                    v-if="signupInfo.promiseContent"
                    :src="signupInfo.promiseContent"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </td>
            </tr>
            <tr v-if="signupInfo.payStatus == 1 && recruitNoticeInfo.free == 0">
              <td class="tdcenter">
                <font class="tdcenter" style="color: red">*</font>付款证明
              </td>
              <td colspan="6">
                <el-upload
                  class="avatar-uploader upload_table"
                  :action="uploadImgUrl"
                  :show-file-list="false"
                  :on-success="promiseUploadSuccess"
                  :before-upload="handleBeforeUpload"
                  :headers="headers"
                  :limit="1"
                  :disabled="signupInfo.status > 1"
                  accept=".jpg,.png,.jpeg"
                >
                  <img
                    v-if="signupInfo.payContent"
                    :src="signupInfo.payContent"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </td>
            </tr>
            <tr v-if="signupInfo.status > 1">
              <td class="tdcenter">初审结果</td>
              <td colspan="6">
                {{ signupInfo.status == 2 ? "审核通过" : "审核拒绝" }}
              </td>
            </tr>
            <tr v-if="signupInfo.status == 3">
              <td class="tdcenter">审核拒绝<br />原因</td>
              <td colspan="6">
                {{ signupInfo.auditReasons }}
              </td>
            </tr>
            <tr
              v-if="
                signupInfo.writtenExaminationStatus > 1 &&
                signupInfo.writtenExaminationStatus < 4
              "
            >
              <td class="tdcenter">笔试审核<br />结果</td>
              <td colspan="6">
                {{
                  signupInfo.writtenExaminationStatus == 2
                    ? "审核通过"
                    : "审核拒绝"
                }}
              </td>
            </tr>
            <tr v-if="signupInfo.writtenExaminationStatus == 3">
              <td class="tdcenter">笔试审核<br />拒绝原因</td>
              <td colspan="6">
                {{ signupInfo.writtenExaminationReasons }}
              </td>
            </tr>
            <tr
              v-if="
                signupInfo.interviewStatus > 1 && signupInfo.interviewStatus < 4
              "
            >
              <td class="tdcenter">面试审核<br />结果</td>
              <td colspan="6">
                {{ signupInfo.interviewStatus == 2 ? "审核通过" : "审核拒绝" }}
              </td>
            </tr>
            <tr
              v-if="
                signupInfo.interviewStatus > 1 && signupInfo.interviewStatus < 4
              "
            >
              <td class="tdcenter">面试审核<br />拒绝原因</td>
              <td colspan="6">
                {{ signupInfo.interviewReasons }}
              </td>
            </tr>
          </table>

          <div class="mybtns" id="step2BtnTwo" style="position: unset">
            <button
              class="step1 default-btn last-btn"
              @click="nextStep('one')"
              v-if="signupInfo.status < 2 || signupInfo.status == 3"
            >
              上一步
            </button>
            <!-- <button
              v-if="signupInfo.status == 3"
              class="step3 default-btn next-btn"
              @click="goSignup('xiugai')"
            >
              修改
            </button> -->
            <button
              v-if="signupInfo.status == 0"
              class="step3 default-btn next-btn"
              @click="goSignup('zancun')"
            >
              暂存
            </button>
            <button
              v-if="signupInfo.status == 0 || signupInfo.status == 3"
              class="step3 default-btn next-btn"
              @click="goSignup('tijiao')"
            >
              提交
            </button>
          </div>
        </div>
      </div>

      <div id="demo-right" v-if="signupInfo.status < 2">
        <div class="common-steps-container">
          <div
            class="common-step-item common-step-active-item"
            v-if="signupInfo.status < 2"
          >
            <div class="common-step-item-circle common-step-item-active-circle">
              1
            </div>
          </div>
          <div
            class="common-step-item"
            :class="currentStep != 'one' ? 'common-step-active-item' : ''"
          >
            <div
              class="common-step-item-circle"
              :class="
                currentStep != 'one' ? 'common-step-item-active-circle' : ''
              "
            >
              2
            </div>
          </div>
          <div class="common-step-item" v-if="signupInfo.payStatus != 1">
            <div
              class="common-step-item-circle"
              :class="
                currentStep == 'three' ? 'common-step-item-active-circle' : ''
              "
            >
              3
            </div>
          </div>
          <!-- <div class="common-step-item">
            <div class="common-step-item-circle">4</div>
          </div> -->
        </div>
      </div>

      <!-- 信息确认框 -->
      <el-dialog
        v-if="messageDialog"
        title="信息确认"
        :visible.sync="messageDialog"
        width="50%"
        append-to-body
        :before-close="handleCloseMessageDialog"
      >
        <el-form :model="signupInfo" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名">
                {{ signupInfo.name }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式">
                {{ signupInfo.telephone }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="身份证号">
                {{ signupInfo.cardNum }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱">
                {{ signupInfo.email }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="应聘单位">
                {{ signupInfo.companyName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应聘岗位">
                {{ signupInfo.postName + "(" + signupInfo.postNum + ")" }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="messageDialog = false">取 消</el-button>
          <el-button type="primary" @click="goSignupReal('tijiao')"
            >确 定
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from "@/request";
import { re } from "semver";

export default {
  labelVal: "",
  name: "SignUp",
  props: {
    recruitId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["png", "jpg", "jpeg"],

      showSignUp: false,
      userInfo: {},
      zgEducation: {
        degree: 6,
      },
      yjsEducation: {
        degree: 5,
      },
      fullEducation: {
        degree: 4,
      },
      zkEducation: {},
      partEducation: {},
      workExperienceList: [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 3,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 4,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
      ],
      certificateList: [
        { id: 1, name: "", grade: "", getTime: "", organization: "" },
        { id: 2, name: "", grade: "", getTime: "", organization: "" },
        { id: 3, name: "", grade: "", getTime: "", organization: "" },
        { id: 4, name: "", grade: "", getTime: "", organization: "" },
      ],

      nations: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      degreeList: [
        { name: "高中以下", value: 1 },
        { name: "高中/中专", value: 2 },
        // { name: "中专", value: 7 },
        { name: "大专", value: 3 },
        { name: "本科", value: 4 },
        { name: "研究生", value: 5 },
        { name: "博士", value: 6 },
      ],
      currentStep: "one",
      signupInfo: {
        status: 0,
      },
      signupReadOnly: false,

      total: 0,
      pageNum: 1,
      pageSize: 10,
      post: {
        noticeId: "",
      },
      currentRow: {},
      recruitPostList: [],
      recruitNoticeInfo: {},
      noticeInfo: {},
      // 籍贯
      nativePlaceOptions: [],
      // 现住址
      presentAddressOptions: [],
      treeSelect: {
        label: "areaName",
        value: "areaName",
        level: "level",
      },
      schoolFeatureList: [],
      messageDialog: false,
    };
  },
  watch: {},
  mounted() {
    let _this = this;
    _this.getNoticeInfo();
    _this.getSysArea();
    _this.getSchoolFeatureList();
    // _this.getSignupInfo();
  },
  methods: {
    educationTypeChange() {
      if (this.signupInfo.degree == "6") {
        this.zgEducation.educationType = this.signupInfo.educationType;
      }
      if (this.signupInfo.degree == "5") {
        this.yjsEducation.educationType = this.signupInfo.educationType;
      }
      if (this.signupInfo.degree == "4") {
        this.fullEducation.educationType = this.signupInfo.educationType;
      }
      if (this.signupInfo.degree <= 3) {
        this.zkEducation.educationType = this.signupInfo.educationType;
      }
    },
    // 查询 中国地区
    getSysArea() {
      let _this = this;
      _this.$api.sign.getSysAreaList().then((res) => {
        // 籍贯
        _this.nativePlaceOptions = res.data;
        // 现住址
        _this.presentAddressOptions = res.data;
      });
    },
    // 查询高校类型
    getSchoolFeatureList() {
      let _this = this;
      _this.$api.sign.getSchoolFeatureList().then((res) => {
        _this.schoolFeatureList = res.data;
      });
    },
    addrow() {
      let _this = this;
      _this.workExperienceList.push({
        id: _this.$util.uuid(),
        startEndTime: "",
        startTime: null,
        endTime: null,
        uintDept: "",
        post: "",
        duty: "",
      });
    },
    addrowCert() {
      let _this = this;
      _this.certificateList.push({
        id: _this.$util.uuid(),
        name: "",
        grade: "",
        getTime: "",
        organization: "",
      });
    },
    delrow(row) {
      let _this = this;
      _this.workExperienceList = _this.workExperienceList.filter(
        (item) => item.id != row.id
      );
    },
    delrowCert(row) {
      let _this = this;
      _this.certificateList = _this.certificateList.filter(
        (item) => item.id != row.id
      );
    },
    getNoticeInfo() {
      let _this = this;
      let parmas = {
        id: _this.recruitId,
      };
      _this.$api.recruitNotice
        .getRecruitNoticeDetail(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.recruitNoticeInfo = res.data;
            _this.noticeInfo = res.data;
          }
        })
        .catch(() => {});
    },
    hidder() {
      let _this = this;
      if (!_this.signupInfo.status) {
        _this.$layer.confirm(
          "该报名尚未提交,是否关闭此窗口?",
          {
            btn: ["确定", "取消"], // 按钮
          },
          function (index) {
            _this.showSignUp = false;
            _this.signupInfo = {};
            _this.fullEducation = {};
            _this.partEducation = {};
            _this.currentRow = {};
            _this.currentStep = "one";

            _this.$layer.close(index);
          },
          function (index) {
            _this.$layer.close(index);
          }
        );
      } else {
        _this.showSignUp = false;
        _this.signupInfo = {};
        _this.currentRow = {};
        _this.currentStep = "one";
      }
      _this.$emit("getMySign");
    },
    nextStep(val) {
      let _this = this;
      if (val == "two") {
        if (!_this.signupInfo.id) {
          if (!_this.currentRow.id) {
            _this.$layer.alert("请选择岗位");
            return;
          } else {
            //查询本招聘公告下的最近的一次报名信息
            _this.getSignupInfoRecent();
          }
        } else if (
          _this.signupInfo.status == 0 ||
          _this.signupInfo.status == 1 ||
          _this.signupInfo.status == 3
        ) {
          _this.signupInfo.postId = _this.currentRow.id;
          _this.signupInfo.companyName = _this.currentRow.unit;
          _this.signupInfo.postName = _this.currentRow.name;
          _this.signupInfo.postNum = _this.currentRow.code;
        }
      }
      if (val == "three") {
        if (!_this.signupInfo.promiseContent) {
          _this.$layer.alert("请上传个人诚信承诺书!");
          return;
        }
        if (!_this.signupInfo.id && _this.signupInfo.status <= 1) {
          _this.goSignup();
        } else {
          _this.currentStep = val;
        }
      } else {
        _this.currentStep = val;
      }
    },
    showTip() {
      let _this = this;
      if (!_this.signupInfo.payContent) {
        _this.$layer.alert("请上传缴费证明!");
        return;
      }
      let param = {
        id: _this.signupInfo.id,
        payContent: _this.signupInfo.payContent,
        payStatus: 1,
        status: 1,
      };
      _this.$api.sign
        .updateSignInfo(param)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.$layer.alert("报名成功!");
            _this.signupInfo.payStatus = 1;
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getUserInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            if (
              !_this.signupInfo.id ||
              _this.signupInfo.status == 0 ||
              _this.signupInfo.status == 3
            ) {
              // _this.userInfo = res.data;
              _this.signupInfo.name = res.data.name;
              _this.signupInfo.gender = res.data.gender;
              _this.signupInfo.birthday = res.data.birthday;
              _this.signupInfo.telephone = res.data.telephone;
              _this.signupInfo.email = res.data.email;
              _this.signupInfo.cardNum = res.data.cardNum;
              _this.signupInfo.headUrl = res.data.headUrl;
              _this.$forceUpdate();
            }
          } else {
            _this.$layer.success(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      // this.getPostList();
    },
    getPostList() {
      let _this = this;
      _this.post.noticeId = _this.recruitId;
      let parmas = {
        ..._this.post,
      };
      _this.$api.recruitNotice
        .getRecruitPosts(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.recruitPostList = res.data;
            if (_this.signupInfo.id) {
              _this.recruitPostList.forEach((item) => {
                if (item.id == _this.signupInfo.postId) {
                  _this.currentRow = item;
                }
              });
            }
          }
        })
        .catch(() => {});
    },

    choosePost(row) {
      let _this = this;
      let params = {
        recruitId: _this.recruitId,
        postId: row.id,
        id: _this.signupInfo.id,
      };
      _this.$api.sign
        .checkIsSign(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.currentRow = row;
            _this.$forceUpdate();
          } else {
            _this.$layer.alert(res.msg);
            _this.currentRow = {};
            _this.signupInfo.postId = null;
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getSignUpById(id) {
      let _this = this;
      let params = {
        id: id,
      };
      _this.workExperienceList = [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 3,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 4,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
      ];
      _this.certificateList = [
        { id: 1, name: "", grade: "", getTime: "", organization: "" },
        { id: 2, name: "", grade: "", getTime: "", organization: "" },
        { id: 3, name: "", grade: "", getTime: "", organization: "" },
        { id: 4, name: "", grade: "", getTime: "", organization: "" },
      ];
      _this.zgEducation = {};
      _this.yjsEducation = {};
      _this.fullEducation = {};
      _this.zkEducation = {};
      _this.partEducation = {};
      _this.$api.sign
        .getById(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            if (res.data) {
              _this.signupInfo = res.data;
              if (_this.signupInfo.workExperience) {
                _this.workExperienceList = JSON.parse(
                  _this.signupInfo.workExperience
                );
              }

              if (_this.signupInfo.certificate) {
                _this.certificateList = JSON.parse(
                  _this.signupInfo.certificate
                );
              }
              if (_this.signupInfo.zgEducation) {
                _this.zgEducation = JSON.parse(_this.signupInfo.zgEducation);
                if (
                  !_this.zgEducation.startEndTime &&
                  _this.zgEducation.startTime &&
                  _this.zgEducation.endTime
                ) {
                  _this.zgEducation.startEndTime = [];
                  _this.zgEducation.startEndTime.push(
                    _this.zgEducation.startTime
                  );
                  _this.zgEducation.startEndTime.push(
                    _this.zgEducation.endTime
                  );
                }
              }

              if (_this.signupInfo.yjsEducation) {
                _this.yjsEducation = JSON.parse(_this.signupInfo.yjsEducation);
                if (
                  !_this.yjsEducation.startEndTime &&
                  _this.yjsEducation.startTime &&
                  _this.yjsEducation.endTime
                ) {
                  _this.yjsEducation.startEndTime = [];
                  _this.yjsEducation.startEndTime.push(
                    _this.yjsEducation.startTime
                  );
                  _this.yjsEducation.startEndTime.push(
                    _this.yjsEducation.endTime
                  );
                }
              }
              if (_this.signupInfo.fullEducation) {
                _this.fullEducation = JSON.parse(
                  _this.signupInfo.fullEducation
                );
                if (
                  !_this.fullEducation.startEndTime &&
                  _this.fullEducation.startTime &&
                  _this.fullEducation.endTime
                ) {
                  _this.fullEducation.startEndTime = [];
                  _this.fullEducation.startEndTime.push(
                    _this.fullEducation.startTime
                  );
                  _this.fullEducation.startEndTime.push(
                    _this.fullEducation.endTime
                  );
                }
              }
              if (_this.signupInfo.zkEducation) {
                _this.zkEducation = JSON.parse(_this.signupInfo.zkEducation);
                if (
                  !_this.zkEducation.startEndTime &&
                  _this.zkEducation.startTime &&
                  _this.zkEducation.endTime
                ) {
                  _this.zkEducation.startEndTime = [];
                  _this.zkEducation.startEndTime.push(
                    _this.zkEducation.startTime
                  );
                  _this.zkEducation.startEndTime.push(
                    _this.zkEducation.endTime
                  );
                }
              }
              if (_this.signupInfo.partEducation) {
                _this.partEducation = JSON.parse(
                  _this.signupInfo.partEducation
                );
                if (
                  !_this.partEducation.startEndTime &&
                  _this.partEducation.startTime &&
                  _this.partEducation.endTime
                ) {
                  _this.partEducation.startEndTime = [];
                  _this.partEducation.startEndTime.push(
                    _this.partEducation.startTime
                  );
                  _this.partEducation.startEndTime.push(
                    _this.partEducation.endTime
                  );
                }
              }
              if (_this.signupInfo.current) {
                _this.signupInfo.currentInfo =
                  _this.signupInfo.current.split(",");
              }
              if (_this.signupInfo.nativePlace) {
                _this.signupInfo.nativePlaceInfo =
                  _this.signupInfo.nativePlace.split(",");
              }
              if (
                _this.signupInfo.status == 1 ||
                _this.signupInfo.status == 0 ||
                _this.signupInfo.status == 3
              ) {
                _this.getUserInfo();
              } else {
                _this.currentStep = "two";
              }
            }
          } else {
            _this.$layer.alert(res.msg);
          }
          _this.getPostList();
          _this.getNoticeInfo();
        })
        .catch(() => {})
        .finally(() => {});
    },
    getSignupInfoRecent() {
      let _this = this;
      let params = {
        // recruitId: _this.recruitId,
      };
      _this.workExperienceList = [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 3,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 4,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
      ];
      _this.certificateList = [
        { id: 1, name: "", grade: "", getTime: "", organization: "" },
        { id: 2, name: "", grade: "", getTime: "", organization: "" },
        { id: 3, name: "", grade: "", getTime: "", organization: "" },
        { id: 4, name: "", grade: "", getTime: "", organization: "" },
      ];
      _this.yjsEducation = {};
      _this.zgEducation = {};
      _this.fullEducation = {};
      _this.zkEducation = {};
      _this.partEducation = {};
      _this.$api.sign
        .getUserSignInfoRecent(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            if (res.data) {
              _this.signupInfo = res.data;
              _this.signupInfo.educationType = null;
              _this.signupInfo.degree = null;
              _this.signupInfo.id = null;
              _this.signupInfo.status = 0;
              if (_this.signupInfo.workExperience) {
                _this.workExperienceList = JSON.parse(
                  _this.signupInfo.workExperience
                );
              }
              if (_this.signupInfo.certificate) {
                _this.certificateList = JSON.parse(
                  _this.signupInfo.certificate
                );
              }
              if (_this.signupInfo.zgEducation) {
                _this.zgEducation = JSON.parse(_this.signupInfo.zgEducation);
              }
              if (_this.signupInfo.yjsEducation) {
                _this.yjsEducation = JSON.parse(_this.signupInfo.yjsEducation);
              }
              if (_this.signupInfo.fullEducation) {
                _this.fullEducation = JSON.parse(
                  _this.signupInfo.fullEducation
                );
              }
              if (_this.signupInfo.partEducation) {
                _this.partEducation = JSON.parse(
                  _this.signupInfo.partEducation
                );
              }
              if (_this.signupInfo.zkEducation) {
                _this.zkEducation = JSON.parse(_this.signupInfo.zkEducation);
              }
              if (_this.signupInfo.current) {
                _this.signupInfo.currentInfo =
                  _this.signupInfo.current.split(",");
              }
              if (_this.signupInfo.nativePlace) {
                _this.signupInfo.nativePlaceInfo =
                  _this.signupInfo.nativePlace.split(",");
              }
            }

            _this.signupInfo.postId = _this.currentRow.id;
            _this.signupInfo.companyName = _this.currentRow.unit;
            _this.signupInfo.postName = _this.currentRow.name;
            _this.signupInfo.postNum = _this.currentRow.code;
            _this.getUserInfo();
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getSignupInfo() {
      let _this = this;
      let params = {
        recruitId: _this.recruitId,
      };
      _this.workExperienceList = [
        {
          id: 1,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 2,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 3,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
        {
          id: 4,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: "",
        },
      ];
      _this.certificateList = [
        { id: 1, name: "", grade: "", getTime: "", organization: "" },
        { id: 2, name: "", grade: "", getTime: "", organization: "" },
        { id: 3, name: "", grade: "", getTime: "", organization: "" },
        { id: 4, name: "", grade: "", getTime: "", organization: "" },
      ];
      _this.zgEducation = {};
      _this.yjsEducation = {};
      _this.fullEducation = {};
      _this.zkEducation = {};
      _this.partEducation = {};
      _this.$api.sign
        .getUserSignInfo(params)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            if (res.data) {
              _this.signupInfo = res.data;
              if (_this.signupInfo.workExperience) {
                _this.workExperienceList = JSON.parse(
                  _this.signupInfo.workExperience
                );
              }
              if (_this.signupInfo.certificate) {
                _this.certificateList = JSON.parse(
                  _this.signupInfo.certificate
                );
              }
              if (_this.signupInfo.zgEducation) {
                _this.zgEducation = JSON.parse(_this.signupInfo.zgEducation);
              }
              if (_this.signupInfo.fullEducation) {
                _this.fullEducation = JSON.parse(
                  _this.signupInfo.fullEducation
                );
              }
              if (_this.signupInfo.yjsEducation) {
                _this.yjsEducation = JSON.parse(_this.signupInfo.yjsEducation);
              }
              if (_this.signupInfo.fullEducation) {
                _this.fullEducation = JSON.parse(
                  _this.signupInfo.fullEducation
                );
              }
              if (_this.signupInfo.zkEducation) {
                _this.zkEducation = JSON.parse(_this.signupInfo.zkEducation);
              }
              if (_this.signupInfo.partEducation) {
                _this.partEducation = JSON.parse(
                  _this.signupInfo.partEducation
                );
              }
              if (_this.signupInfo.current) {
                _this.signupInfo.currentInfo =
                  _this.signupInfo.current.split(",");
              }
              if (_this.signupInfo.nativePlace) {
                _this.signupInfo.nativePlaceInfo =
                  _this.signupInfo.nativePlace.split(",");
              }
              if (
                _this.signupInfo.status == 1 ||
                _this.signupInfo.status == 0
              ) {
                _this.getUserInfo();
              }
            } else {
              _this.getUserInfo();
            }
            _this.getPostList();
            // _this.userInfo = res.data.user;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    goSignup(val) {
      let _this = this;
      if (val && val == "zancun") {
        _this.goSignupReal("zancun");
      } else {
        if (!_this.signupInfo.nation) {
          _this.$layer.alert("请选择民族!");
          return;
        }
        if (!_this.signupInfo.nativePlaceInfo) {
          _this.$layer.alert("请选择籍贯!");
          return;
        }
        if (!_this.signupInfo.birthAddress) {
          _this.$layer.alert("请填写出生地!");
          return;
        }
        if (!_this.signupInfo.political) {
          _this.$layer.alert("请选择政治面貌!");
          return;
        }
        if (!_this.signupInfo.isMarry) {
          _this.$layer.alert("请选择婚姻状况!");
          return;
        }
        if (!_this.signupInfo.height) {
          _this.$layer.alert("请填写身高!");
          return;
        }
        if (!_this.signupInfo.health) {
          _this.$layer.alert("请选择健康状态!");
          return;
        }
        if (!_this.signupInfo.degree) {
          _this.$layer.alert("请选择学历!");
          return;
        }
        if (!_this.signupInfo.educationType) {
          _this.$layer.alert("请选择教育类型!");
          return;
        }
        if (
          _this.signupInfo.socialInsurance === 0 ||
          _this.signupInfo.socialInsurance === 1
        ) {
        } else {
          _this.$layer.alert("请选择是否缴纳过社保!");
          return;
        }
        if (!_this.signupInfo.currentInfo) {
          _this.$layer.alert("请选择现住址!");
          return;
        }
        if (!_this.signupInfo.workTime) {
          _this.$layer.alert("请填写参加工作时间!");
          return;
        }
        if (!_this.signupInfo.workCompany) {
          _this.$layer.alert("请填写现工作单位!");
          return;
        }
        if (!_this.signupInfo.workDeptPost) {
          _this.$layer.alert("请填写现工作部门及岗位!");
          return;
        }
        if (!_this.signupInfo.workDeptPost) {
          _this.$layer.alert("请填写现工作部门及岗位!");
          return;
        }
        if (_this.signupInfo.degree == 6) {
          if (!_this.checkEducation(_this.zgEducation, "博士阶段")) {
            return;
          }
        }
        if (_this.signupInfo.degree >= 5) {
          if (!_this.checkEducation(_this.yjsEducation, "研究生阶段")) {
            return;
          }
        }
        if (_this.signupInfo.degree >= 4) {
          if (!_this.checkEducation(_this.fullEducation, "本科阶段")) {
            return;
          }
        }
        if (!_this.checkEducation(_this.zkEducation, "专科及以下阶段")) {
          return;
        }

        if (
          !_this.signupInfo.promiseContent &&
          _this.recruitNoticeInfo.promise
        ) {
          _this.$layer.alert("请上传个人诚信承诺书!");
          return;
        }
        if(_this.signupInfo.qsIn!='0' && _this.signupInfo.qsIn!=1){
          _this.$layer.alert("请选择是否有亲属在拟应聘企业及上级企业任职!");
          return;
        }
        if(_this.signupInfo.qsIn==1){
          if(!_this.signupInfo.qsRelation){
            _this.$layer.alert("请填写亲属关系!");
            return;
          }
          if(!_this.signupInfo.qsUnit){
            _this.$layer.alert("请填写亲属任职单位及职务!");
            return;
          }
        }
        _this.messageDialog = true;
      }
    },
    goSignupReal(val) {
      let _this = this;

      _this.signupInfo.postId = _this.currentRow.id;
      _this.signupInfo.zgEducation = JSON.stringify(_this.zgEducation);
      _this.signupInfo.yjsEducation = JSON.stringify(_this.yjsEducation);
      _this.signupInfo.fullEducation = JSON.stringify(_this.fullEducation);
      _this.signupInfo.zkEducation = JSON.stringify(_this.zkEducation);
      _this.signupInfo.partEducation = JSON.stringify(_this.partEducation);

      _this.signupInfo.current = _this.signupInfo.currentInfo.join(",");
      _this.signupInfo.nativePlace = _this.signupInfo.nativePlaceInfo.join(",");

      _this.signupInfo.workExperience = JSON.stringify(
        _this.workExperienceList
      );
      _this.signupInfo.certificate = JSON.stringify(_this.certificateList);
      let signStatus = _this.signupInfo.signStatus
        ? _this.signupInfo.signStatus
        : 0;
      if (_this.signupInfo.id) {
        if (val == "tijiao") {
          if (_this.noticeInfo.sendResume == 0) {
            _this.signupInfo.status = 1;
          } else {
            _this.signupInfo.status = -1;
          }
        } else {
          _this.signupInfo.status = 0;
        }
        _this.$api.sign
          .updateSignInfo(_this.signupInfo)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.messageDialog = false;
              _this.$layer.alert("操作成功");
            } else {
              _this.signupInfo.status = signStatus;
              _this.messageDialog = false;
              _this.$layer.alert(res.msg);
            }
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$layer.load(0, { shade: 0.6 });
        if (val == "tijiao") {
          if (_this.noticeInfo.sendResume == 0) {
            _this.signupInfo.status = 1;
          } else {
            _this.signupInfo.status = -1;
          }
        } else {
          _this.signupInfo.status = 0;
        }
        _this.signupInfo.recruitId = _this.recruitId;
        _this.$api.sign
          .addSignInfo(_this.signupInfo)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.signupInfo.id = res.data;
              if (val == "tijiao") {
                _this.$layer.alert("提交成功", function () {
                  _this.$layer.closeAll();
                  _this.messageDialog = false;
                });
              } else {
                _this.$layer.alert("保存成功", function () {
                  _this.$layer.closeAll();
                  _this.messageDialog = false;
                });
              }
            } else {
              _this.signupInfo.status = signStatus;
              _this.messageDialog = false;
              _this.$layer.alert(res.msg, function (index) {
                _this.$layer.close(index);
                _this.$layer.closeAll();
              });
              //
            }
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    eduTimeChange(e, type) {
      if (e) {
        this[type].startTime = e[0];
        this[type].endTime = e[1];
      }
    },
    workTimeChange(e, item) {
      if (e) {
        item.startTime = e[0];
        item.endTime = e[1];
      }
    },

    // 上传成功回调
    promiseUploadSuccess(res) {
      let _this = this;
      // this.fileList = [];
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.signupInfo.promiseContent = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },

    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
        );
        return false;
      }
      const isLt = file.size / 1024 / 1024 < 5;
      if (!isLt) {
        this.$modal.msgError(`上传图片大小不能超过 5MB!`);
        return false;
      }

      this.$modal.loading("正在上传图片，请稍候...");
    },
    checkEducation(info, eduName) {
      if (JSON.stringify(info) == "{}") {
        this.$layer.alert(`请填写${eduName}信息`);
        return false;
      }
      if (!info.startEndTime) {
        this.$layer.alert(`请选择${eduName}的起止时间`);
        return false;
      } else {
        info.startTime = info.startEndTime[0];
        info.endTime = info.startEndTime[1];
      }
      if (!info.college) {
        this.$layer.alert(`请填写${eduName}的院校`);
        return false;
      }
      if (!info.major) {
        this.$layer.alert(`请填写${eduName}的专业`);
        return false;
      }
      if (!info.degree) {
        this.$layer.alert(`请选择${eduName}的学历`);
        return false;
      }
      if (!info.educationType) {
        this.$layer.alert(`请选择${eduName}的教育类型`);
        return false;
      }
      if (!info.schoolType) {
        this.$layer.alert(`请选择${eduName}的院校类别`);
        return false;
      }
      return true;
    },
    handleCloseMessageDialog() {
      this.messageDialog = false;
    },
    handleChange() {
      this.getdata();
    },
    getdata() {
      this.labelVal = this.$refs.cascader_Ref
        .getCheckedNodes()[0]
        .pathLabels.join("/");
    },
  },
};
</script>
<style scoped>
select {
  width: 100px;
  background: #fff;
  border: 1px solid #ededed;
  padding: 2px 0 2px 5px;
  border-radius: 4px;
}

.header-right {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #909399;
  color: #fff;
  right: 5px;
  top: 5px;
  text-align: center;
  cursor: pointer;
}

.header {
  height: 40px;
}

.tankuang {
  position: relative;
  background: #fff;
  height: 100%;
  border-radius: 5px;
  margin: auto;
}

input.error {
  border: 1px solid red !important;
}

label.error {
  font-size: 12px;
  color: #ea5200;
}

.rowBtn {
  width: 88px !important;
  height: 34px;
  background: none;
  border: 1px #ccc solid;
  color: #333;
  margin-left: 10px;
}

.table {
  width: 100%;
  border-top: 1px #ddd solid;
  border-left: 1px #ddd solid;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 4px;
}

.table tr td {
  border-right: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
  padding: 4px 15px;
  height: 40px;
}

.table input {
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
  width: 100px;
}

.innertable input {
  width: 100px;
}

.table textarea {
  width: 100%;
  height: 100px;
  flex: 1;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
}

.tdcenter {
  text-align: center;
}

.upload_table >>> ::v-deep .el-upload__input {
  display: none !important;
}

.upload_table >>> ::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-cascader {
  width: 200px;
}
</style>
<style>
.el-date-editor .el-range__close-icon {
  width: 0px !important;
}

.el-select-dense >>> input {
  height: 35px;
}

.el-select-dense >>> .el-input__icon {
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/signUp.vue